"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callDispositions = void 0;
var callDispositions;
(function (callDispositions) {
    callDispositions["INVALID_NUMBER"] = "invalid_number";
    callDispositions["CALL_CONNECTED"] = "success";
    callDispositions["ANSWERING_MACHINE"] = "answering_machine";
    callDispositions["BUSY_TONE"] = "busy";
    callDispositions["NO_ANSWER"] = "no_answer";
    callDispositions["CALL_HANG_UP_BEFORE_CONNECTION"] = "hangup_before_connection";
    callDispositions["CALL_ABANDONED"] = "abandoned";
    callDispositions["UNREACHABLE"] = "unreachable";
})(callDispositions || (exports.callDispositions = callDispositions = {}));
